/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';

import { spacing, typography } from '$variables/theme';
import colors from '$variables/colors';

export const GradeBox = styled.div`
  width: 150px;
  height: 40px;
  padding: ${spacing.small} ${spacing.xxSmall};

  display: flex;
  align-items: center;

  color: ${colors.shadow6};
  font-weight: ${typography.fontWeightSemiBold};
`;
